import topic from '../topic';

export const frqtaAPI = {
  addFactoryInquiryForm: topic.frtaTopic + '/addFactoryInquiryForm',
  getFactoryInquiryFormById: topic.frtaTopic + '/getFactoryInquiryFormById',
  getErpSupplierList: topic.openTopic + '/erp/api/getERPSupplierInformation',
  getFactoryInquiryForms: topic.frtaTopic + '/getFactoryInquiryForms',
  editFactoryInquiryForm: topic.frtaTopic + '/editFactoryInquiryForm',
  destroyFactoryInquiryFormByIds: topic.frtaTopic + '/destroyFactoryInquiryFormByIds'
};
